module.exports = __webpack_public_path__ + "static/media/JOE.fa71f645.png";